import { useDebounce } from '../components/account/helpers/useDebounce';
import { getImageUrl, getUserName } from './helpers';
import { getGravatarUrl } from 'react-awesome-gravatar';
import { api, AppDataContext, getUserMetadataAPI, inIframe } from '../';
import { useContext, useEffect, useState } from 'react';

function useGetGravatarOrUploadedProfileImg(userMetaData) {
  const { appData, setAppData } = useContext(AppDataContext);
  const [profilePic, setProfilePic] = useState(getImageUrl(''));
  const [isProfilePicSet, setIsProfilePicSet] = useState(false);

  useEffect(() => {
    const username = getUserName();
    if (Object.keys(appData?.userMetaData).length === 0 && username) {
      //userMetaData empty
      getUserMetadataAPI(username, (updatedUserMetaData) => {
        setAppData({
          ...appData,
          userMetaData: { ...updatedUserMetaData },
        });
      });
    }
  }, []);

  useDebounce(
    () => {
      if (
        userMetaData?.profile_image?.has_image ||
        (inIframe() && userMetaData?.profile_image?.image_url_full)
      ) {
        setProfilePic(getImageUrl(userMetaData?.profile_image?.image_url_full));
        setIsProfilePicSet(true);
      } else if (!inIframe()) {
        const gravatarURL = getGravatarUrl(appData.userData?.user_email, {
          default: '404',
          size: 80,
          defaultUrl: appData.userMetaData?.profile_image?.image_url_full,
        });
        //If gravatar img doesn't exist for user email
        if (String(gravatarURL).includes('default=404')) {
          setProfilePic(
            getImageUrl(userMetaData?.profile_image?.image_url_full)
          );
        } else {
          setProfilePic(gravatarURL);
        }
        setIsProfilePicSet(true);
      }
    },
    300,
    [appData?.userMetaData, userMetaData]
  );

  return {
    profilePic,
    isProfilePicSet,
    setIsProfilePicSet,
    setProfilePic,
  };
}

export { useGetGravatarOrUploadedProfileImg };
